import styled from 'styled-components';
import { Accordion } from 'semantic-ui-react';

const ContainerAccordion = styled.div`
  padding: 5px 0;
`;

const CustomAccordion = styled(Accordion)`
  &&& {
    border-radius: 0;
    border: solid 1px ${(props) => props.theme.color.checkboxAccordion};
    box-shadow: 0 0 #fff;
    margin: 0;
  }
`;

const FloatRight = styled.div`
  display: inline-block;
  float: right;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
  white-space: nowrap;
`;

const ContainerSelector = styled.div`
  margin-left: 20px;
  padding: 0 1em 1.5em;
`;

export {
  ContainerAccordion,
  FloatRight,
  CustomAccordion,
  ContainerSelector,
};
